module.exports = __webpack_public_path__ + "img/check-square.c4e2a945.svg";